import { render, staticRenderFns } from "./filters-item.vue?vue&type=template&id=5e872d1a&"
import script from "./filters-item.vue?vue&type=script&lang=js&"
export * from "./filters-item.vue?vue&type=script&lang=js&"
import style0 from "./filters-item.vue?vue&type=style&index=0&id=5e872d1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports